<template>
  <ContentContainer v-if="hasContent" class="py-0">
    <section class="image-only grid gap-[42px] py-[42px] lg:py-21">
      <slot name="contentCopy" />
    </section>
  </ContentContainer>
</template>

<script setup lang="ts">
import { provide, ref } from 'vue';

const { alternateDirection = '0' } = defineProps<{
  alternateDirection?: '1' | '0';
}>();

defineSlots<{
  contentCopy(): any;
}>();

const hasContent = useSlotHasContent('contentCopy');

const childCounter = ref(0);
provide('alternateDirection', alternateDirection);
provide('alternateChildCounter', childCounter);
</script>
